import { Endpoints } from '@/api/ApiEndpoints';
const Catalogue = {
	Plural: 'Catalogue',
	Single: 'Catalogue',
	ParentID: 'ParentCategoryID',
	SearchDisabled: true,
	updateOrder: true,
	Columns: [
		{
			name: '',
			label: '#',
			type: 'counter',
		},
		{
			name: 'name',
			dbName: 'Name',
			label: 'Name',
			type: 'text',
			sortable: true,
		},
		
	],
	Filters: [
		
	],
	PrimaryKey: 'id',
	Actions: {
		pageLink: '/catalogue/category',
		
	},
};

export default Catalogue;
